import { render } from "./Onboarding.vue?vue&type=template&id=0f3af954&scoped=true"
import script from "./Onboarding.vue?vue&type=script&lang=ts"
export * from "./Onboarding.vue?vue&type=script&lang=ts"

import "./Onboarding.vue?vue&type=style&index=0&id=0f3af954&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0f3af954"

export default script